import { useMutation } from 'react-query';
import { ReportDiagnosticParams } from './Report.types';
import { useServiceError } from '@/hooks';
import { generateDiagnosticReport } from './Report.service';

export function useDiagnosticReport() {
  const mutation = useMutation((obj: ReportDiagnosticParams) =>
    generateDiagnosticReport(obj),
  );

  useServiceError(mutation.error);

  return mutation;
}
